//Doubletree Mobile Enhancements
$(function () {
  $(function () {
    $("#promo-banner").insertBefore(".content");
  });
  $(function () {
    var mobile = false;
    var desktop = false;
    function checkWidth() {
      var viewportWidth = window.viewportSize.getWidth();
      var lastBreadcrumbItem = document.querySelector(
        ".productPg .breadcrumb li:last-child"
      );

      if (lastBreadcrumbItem) {
        lastBreadcrumbItem.innerHTML =
          viewportWidth < 826
            ? '<h1 class="title-prod-mobile">' +
              lastBreadcrumbItem.textContent +
              "</h1>"
            : lastBreadcrumbItem.textContent;
      }

      if (viewportWidth <= 660) {
        if (!mobile) {
          $("#main-nav").insertBefore(".nav");
          $(".sub-header").insertAfter("p.main-logo");
          $("li a.faq").insertAfter("a.email-us");
          $("#pgHome .nav").appendTo(".content");
          $("ul.track_order-form").insertBefore("p.search");
          $(".item-image").insertBefore(".grid-6rt");
          $(".top-promo").insertBefore(".hdr-promo");
          $(".content").addClass("mobile");
          $(".breadcrumb").prependTo(".content");
          $(".item-image a img").not(".item-image .alt-views a img").unwrap();
        }
        mobile = true;
        desktop = false;
      } else {
        if (!desktop) {
          $("#main-nav").prependTo(".nav");
          $("p.main-logo + div.sub-header").appendTo("div.header-inner"); //disabled since it caused the search drop down items to be displayed twice
          $("li a.faq").appendTo("li.support h3");
          $("#pgHome div.nav").insertBefore("div.shop-cart");
          $("ul.track_order-form").insertAfter("div.top");
          $("div.item-image").prependTo("div.product-content");
          $(".content").removeClass("mobile");
          $(".productPg .breadcrumb").prependTo("div.grid-4n");
          $(".categoryPg .breadcrumb").prependTo("div.grid-2rt");
          $("div.hdr-promo").insertAfter("p.search");
        }
        mobile = false;
        desktop = true;
      }
    }
    checkWidth();
    $(window).on("resize", checkWidth);
  });
  //Buttons for activating menus
  $(function () {
    $("#btn-track-order").on('click', function () {
      $(this).toggleClass("closed open");
      $("ul.track_order-form").slideToggle("fast");
    });
    $("#btn-main-nav").on('click', function () {
      $(this).toggleClass("inactive activated").next().slideToggle("fast");
    });
  });
  $(function () {
    $("#btn-left-nav").on("click", function () {
      $(this)
        .toggleClass("leftnav-inactive leftnav-active")
        .next()
        .toggle("fast");
    });
  });
  //Product Page Item description collapse and tabs
  $(function () {
    $("#item-description")
      .not("html.lt-ie8 #item-description, html.lt-ie9 #item-description")
      .on("click", function () {
        $(this).next().toggle("item-copy");
        $(this).html(
          $(this).html() == "Close product information"
            ? "View product information"
            : "Close product information"
        );
        $(this).toggleClass("closed opened");
        return false;
      })
      .next()
      .hide();
    $("#tabs div").hide();
    $("#tabs div:first").show();
    $("#tabs ul.tab-links li:first").addClass("active");
    $("#tabs ul.tab-links li a").on("click", function () {
      $("#tabs ul.tab-links li").attr("class", "");
      $(this).parent().attr("class", "active");
      var currentTab = $(this).attr("href");
      $("#tabs div").hide();
      $(currentTab).show();
      return false;
    });
  });

  //Equalize Columns
  $(function () {
    var equalheight = function (container) {
      var currentTallest = 0,
        currentRowStart = 0,
        rowDivs = new Array(),
        $el,
        topPosition = 0;
      $(container).each(function () {
        $el = $(this);
        $($el).height("auto");
        topPosition = $el.position().top;

        if (currentRowStart != topPosition) {
          for (var currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
            rowDivs[currentDiv].height(currentTallest);
          }
          rowDivs.length = 0;
          currentRowStart = topPosition;
          currentTallest = $el.height();
          rowDivs.push($el);
        } else {
          rowDivs.push($el);
          currentTallest =
            currentTallest < $el.height() ? $el.height() : currentTallest;
        }
        for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
          rowDivs[currentDiv].height(currentTallest);
        }
      });
    };
    const equalheightLoad = function () {
      equalheight(".hp-sub-content .sub-copy");
      equalheight(".col");
      equalheight(".item a p");
      equalheight(".similar-items ul li");
      equalheight(".category-content div.item");
      equalheight(".similar-items ul li h3");
    }
    window.addEventListener('load', equalheightLoad);
    window.addEventListener('resize', equalheightLoad);
  });
  //Scroll to Top
  $(function () {
    $("#goTop").hide();
    $(function () {
      $(window).on("scroll", function () {
        if ($(this).scrollTop() > 600) {
          $("#goTop").fadeIn();
        } else {
          $("#goTop").fadeOut();
        }
      });
      $("#goTop a").on('click', function () {
        $("body,html").animate(
          {
            scrollTop: 0,
          },
          250
        );
        return false;
      });
    });
  });
  $(function () {
    var isWebkit = "WebkitAppearance" in document.documentElement.style;
    if (isWebkit) {
      $("html").addClass("isWebkit");
    }
  });

  /* Promo Headers - */
  (function ($) {
    $.fn.flowtype = function (options) {
      var settings = $.extend(
          {
            maximum: 9999,
            minimum: 1,
            maxFont: 9999,
            minFont: 1,
            fontRatio: 35,
          },
          options
        ),
        changes = function (el) {
          var $el = $(el),
            elw = $el.width(),
            width =
              elw > settings.maximum
                ? settings.maximum
                : elw < settings.minimum
                ? settings.minimum
                : elw,
            fontBase = width / settings.fontRatio,
            fontSize =
              fontBase > settings.maxFont
                ? settings.maxFont
                : fontBase < settings.minFont
                ? settings.minFont
                : fontBase;
          $el.css("font-size", fontSize + "px");
        };

      return this.each(function () {
        var that = this;
        $(window).on("resize", function () {
          changes(that);
        });
        changes(this);
      });
    };
  })(jQuery);
  $(".top-promo").flowtype({
    minimum: 420,
    maximum: 990,
    minFont: 10,
    maxFont: 20,
    fontRatio: 55,
  });

  $.letItSnow(".let-it-snow", {
    stickyFlakes: "lis-flake--js",
    makeFlakes: true,
    sticky: true,
  });

  //
});
